import React from 'react'
import pullquoteStyles from './pullquote.module.scss'

const Pullquote = ({ block }) => (
  <blockquote className={`col-md-3 ${pullquoteStyles.blockquote}`}>
    {block.score ? (
      <strong className={`${pullquoteStyles.score}`}>{block.score}</strong>
    ) : (
      ``
    )}
    <span>{block.content}</span>
  </blockquote>
)

export default Pullquote
